<template>
  <div style="flex-wrap: nowrap" class="row justify-content-end">
    <div class="d-flex align-items-center justify-content-end mr-2 mb-md-2">
      <tag-color v-for="tag in company.tags" :key="tag.id" :color="tag.color.name" :name="tag.name" input-class="mr-1" />
    </div>
    <div class="visibility-box p-3 rounded border"
         :class="{'border-green' : company && company.mod_status_id === 5, 'border-red' : company && company.mod_status_id === 3}"
    >
      <div class="col-6 px-0">
        <span class="visible-info"
              v-if="company && company.mod_status_id === 2"
        >
          Request sent
        </span>
        <span class="visible-info"
              v-else-if="company && company.mod_status_id === 3"
        >
          <i class="fa fa-times-circle" aria-hidden="true" />
          <div class="tippy-popup tippy-info"
               @mouseover="showVisibilityTooltip = true"
               @mouseout="showVisibilityTooltip = false"
          >
            <i class="fa fa-info-circle" />
          </div>
          <div class="popover tippy-info-popover"
               v-if="showVisibilityTooltip"
          >
            {{ company && company.review_notification }}
          </div>
          Request denied
        </span>
        <span class="visible-info"
              v-else-if="company && company.mod_status_id === 5"
        >
          <i class="fa fa-check-circle" aria-hidden="true" />
          Listed on mod24
        </span>
        <span class="visible-info"
              v-else-if="company && company.mod_status_id === 1"
        >Appear on mod24 website</span>
      </div>
      <div class="col-6 text-right px-0">
        <button v-if="company && company.mod_status_id === 5"
                type="button"
                class="btn btn-secondary btn-visible px-2"
                @click="cancelVisibility"
        >
          Cancel visibility
        </button>
      </div>
    </div>

    <modal v-if="showApprovalModal" @close="showApprovalModal = false" container="l-modal-container-sm">
      <template slot="header">&nbsp;</template>
      <div class="d-flex flex-column align-items-center px-3" slot="body">
        <img :src="require(`../../assets/img/submit-request.svg`)" alt="Tier select" />
        <h4 class="text-center mt-4">You're about to submit a request to be visible on Mod24 website!</h4>
        <p class="text-center mt-3 px-3">
          Our team will verify your information within the next 48h. A reply will be sent to your company email address.
        </p>

        <p class="text-center mt-3 px-3">
          If you need to change any information, such as images, description, logo, licence number or payments details, it will need additional approval from our team.
        </p>

        <error-field :errors="errors" field="licence_number" />
        <error-field :errors="errors" field="note" />


        <div class="d-flex align-items-center justify-content-center w-100 mt-3">
          <button class="btn btn-secondary mr-1 w-50 btn-decline" @click="showApprovalModal = false">
            No, go back.
          </button>
          <button class="btn btn-primary ml-1 w-50 btn-accept" @click="makeVisible">
            Yes, submit.
          </button>
        </div>
      </div>
      <template slot="footer">&nbsp;</template>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import Modal from '../Modal';
import TagColor from '../settings/Tags/TagColor';

export default {
  components: {
    TagColor,
    ErrorField,
    Modal,
  },
  props: {
    company: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    buttonDisabled: false,
    errors: new Errors(),
    loadingButton: false,
    modTiers: [],
    showApprovalModal: false,
    showVisibilityTooltip: false,
  }),
  computed: {
    licence() {
      return !(this.company.licence === null) ? this.company.licence : {};
    },
  },
  methods: {
    cancelVisibility() {
      axios
        .post(`companies/${this.company.id}/cancel-visibility`)
        .then(() => {
          this.$emit('update');
          toastr.success('Request sent for cancelling visibility');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    makeVisible() {
      const data = {
        licence_number: this.licence.licence_number,
        note: this.licence.note,
      };
      axios
        .post(`companies/${this.company.id}/licences`, data)
        .then(() => {
          axios
            .patch(`companies/${this.company.id}`, { mod_tier_id: this.company.mod_tier_id })
            .then(() => {
              axios.post(`companies/${this.company.id}/request-review`).then(() => {
                this.$emit('saved');
                this.showApprovalModal = false;
                toastr.success('Request sent for Mod24 review');
              });
            })
            .catch(err => this.errors.record(err.response.data.error));
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    openApprovalModal() {
      axios
        .get('mod-tiers')
        .then(res => {
          this.modTiers = res.data.data;
          this.showApprovalModal = true;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/companies/CompaniesVisibilityBar.vue